import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export function initI18n(language: string = "en"): void {
	i18n.use(initReactI18next).init({
		resources: {
			en: englishTranslations,
		},
		lng: language,
		fallbackLng: language,
		interpolation: {
			escapeValue: false,
		},
	});
}

export const englishTranslations: { translation: { [key: string]: string } } = {
	translation: {
		Today: "Today",
		Yesterday: "Yesterday",
		Last7Days: "Last 7 Days",
		Last30Days: "Last 30 Days",
		ThisMonth: "This Month",
		LastMonth: "Last Month",
		Last1Hour: "Last 1 Hour",
	},
};
